import deCodeToken from "jwt-decode";

const authState = {
  loading: false,
  authenticate: false,
  error: "",
  loginError:"",
  successMessage: "",
  myInfo: "",
  users: [],
  parPage: 0,
  userCount: 0,

  editProfile: "",
  editRequest: false,
  myMessages:[],
  myOrder:[],
  deleteMessageSuccess:'',
  deleteOrderSuccess:''

};

const tokenDecode = (token) => {
  const tokenDecoded = deCodeToken(token);
  const expTime = new Date(tokenDecoded.exp * 1000);
  if (new Date() > expTime) {
    return null;
  }
  return tokenDecoded;
};

const getToken = localStorage.getItem("authToken");
if (getToken) {
  const getInfo = tokenDecode(getToken);
  if (getInfo) {
    authState.myInfo = getInfo;
    authState.authenticate = true;
    authState.loading = false;
  }
}

export const authReducer = (state = authState, action) => {
  const { payload, type } = action;
  if (type === "AUTHENTICATION_SET_LOADER") {
    return {
      ...state,
      loading: true,
    };
  }
  if (type === "REGISTER_FAIL" || type === " USER_LOGIN_FAIL") {
    return {
      ...state,
      error: payload.error,
      loginError:payload,
      authenticate: false,
      myInfo: "",
      loading: false,
    };
  }
  if (type === "USER_LOGIN_FAIL") {
    return {
      ...state,
      loginError:payload,
      authenticate: false,
      myInfo: "",
      loading: false,
    };
  }



  if (type === "REGISTER_SUCCESS" || type === "USER_LOGIN_SUCCESS") {
    const myInfo = tokenDecode(payload.token);
    return {
      ...state,
      myInfo: myInfo,
      successMessage: payload.successMessage,
      error: "",
      authenticate: true,
      loading:false,
    };
  }
  if (type === "SUCCESS_MESSAGE_CLEAR") {
    return {
      ...state,
      successMessage: "",
    };
  }
  if (type === "ERROR_CLEAR") {
    return {
      ...state,
      error: "",
    };
  }
  if (type === "LOGOUT_SUCCESS") {
    return {
      ...state,
      authenticate: false,
      myInfo: "",
      successMessage: "Logout successful",
    };
  }
  if (type === "PERPAGE_USER_GET_SUCCESS") {
    return {
      ...state,
      users: payload.allUser,
      userCount: payload.userCount,
      parPage: payload.parPage,
    };
  }
  if (type === "USER_DELETE_SUCCESS") {
    return {
      ...state,
      successMessage: payload,
    };
  }

  if (type === "USER_INFO_GET_SUCCESS") {
    return {
      ...state,
      editProfile: payload,
    };
  }
  if (type === "EDIT_REQUEST_SET") {
    return {
      ...state,
      editRequest: true,
    };
  }

  if (type === "USER_INFO_UPDATE_SUCCESS") {
    return {
      ...state,
      editRequest: true,
      successMessage: payload,
      error: "",
    };
  }
  if (type === "USER_MESSAGE_GET_SUCCESS") {
    return {
      ...state,
      myMessages: payload
    };
  }

  if (type === "USER_ORDER_GET_SUCCESS") {
    return {
      ...state,
      myOrder: payload
    };
  }
  if (type === "USER_MESSAGE_DELETE_SUCCESS") {
    return {
      ...state,
      deleteMessageSuccess: payload
    };
  }

  if (type === "USER_ORDER_DELETE_SUCCESS") {
    return {
      ...state,
      deleteOrderSuccess: payload
    };
  }
  




  return state;
};
